import { Outlet } from "react-router-dom";
import { SectionSubnav } from "@/components/core/SectionSubnav";

export default function SpotLayout() {
  return (
    <div className="pb-8">
      <SectionSubnav
        title="Spot"
        items={[
          { label: "Performance", to: "/app/spot/performance", end: true },
          { label: "Holdings & PnL", to: "/app/spot/holdings-pnl" },
          { label: "Trades", to: "/app/spot/trades" },
          { label: "Insights", to: "/app/spot/insights" },
        ]}
      />
      <Outlet />
    </div>
  );
}
